import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    user: {
      type: [Object, Array, String],
      required: true
    },
    redirect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      loading: 'skiliko/messages/isLoading',
      currentPlatform: 'skiliko/session/currentPlatform'
    }),
    chatableUsers () {
      if (this.user === 'all') {
        return null // default filter with user from the current platform
      }
      if (Array.isArray(this.user)) {
        return this.user.map(e => e._id)
      } else {
        return [this.user._id]
      }
    }
  },
  methods: {
    ...mapActions({
      _send: 'skiliko/messages/create'
    }),
    send ({ content, data = {} }) {
      const query = {
        platform: this.currentPlatform.token,
        scope: 'user'
      }
      if (this.chatableUsers) { query.ids = this.chatableUsers }
      return this._send({
        content,
        data,
        query
      })
        .then(message => {
          if (this.redirect) {
            this.$router.push({
              name: 'MessengerMessage',
              params: {
                id: message.conversation
              }
            })
          }
        })
    },
    sendToConversation (conversationId, message) {
      return this._send({
        conversationId,
        from: this.user._id,
        content: message
      })
        .then(message => {
          if (this.redirect) {
            this.$router.push({
              name: 'MessengerMessage',
              params: {
                id: message.conversation
              }
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chatMessage.js